(ns dashboard.components.confirm-delete-question-answer-modal
  (:require [dashboard.components.confirm-modal :refer [confirm-modal]]))

(defn modal-content []
  [:p "Are you sure you want to delete this answer?"])

(defn confirm-delete-question-answer-modal [{:keys [on-confirm]}]
  (partial #'confirm-modal
           {:title                 "Delete answer?"
            :content               #'modal-content
            :label-confirm         "Delete"
            :invert-button-colors? true
            :notification-classes  ["has-background-danger" "has-text-white" "is-shadowless"]
            :disable-confirm       false
            :on-confirm            on-confirm}))
